import actions from '@gov.wa.lni/application.warehouse-retaliation/source/components/lni-retaliation-form/actions';

export default () => ({
    state: {
        trackedErrors: [],
    },
    actions: {
        ...actions,
    },
    mutations: {
        ADD_TRACKED_ERRORS(state, payload) {
            for (let i = 0; i < payload.length; i++) {
                if (state.trackedErrors.indexOf(payload[i]) === -1) {
                    state.trackedErrors.push(payload[i]);
                }
            }
        },
        REMOVE_TRACKED_ERRORS(state, payload) {
            for (let i = 0; i < payload.length; i++) {
                let index = state.trackedErrors.indexOf(payload[i]);
                if (index > -1) {
                    state.trackedErrors.splice(index, 1);
                }
            }
        },
    },
});